<template>
  <div></div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "Checkout",
  methods: {
    addFieldErrorState: function (field, state) {
      this.$store.commit("basket/addRequiredFieldError", {[field]: state});
    },
    getFieldErrorState: function (field) {
      return this.requiredFieldsState[field] !== undefined ? this.requiredFieldsState[field] : false;
    },
  },
  computed: {
    ...mapGetters('basket', {
      requiredFieldsState: 'getRequiredFieldsState',
      requiredFields: 'getRequiredFields'
    }),
  }
}
</script>

<style scoped>

</style>